module.exports = __webpack_public_path__ + "static/blue-wave-2b3265a842c86e18f18b278a6c92153a.png";